import { useClickOutside } from '@portalterreno/react-ui-core/hooks';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import React, { memo, useState } from 'react';

import StyledButtonDiv from './StyledButtonDiv';
import StyledDiv from './StyledDiv';
import StyledDivMenuDropdown from './StyledDivMenuDropdown';
import StyledList from './StyledList';
import StyledListItem from './StyledListItem';
import StyledOutlineButton from './StyledOutlineButton';
import StyledPlanButton from './StyledPlanButton';

export type MenuDesktopProps = React.HTMLAttributes<HTMLDivElement>;

const MenuDesktop: React.FC<MenuDesktopProps> = (props) => {
  const [isPlanListOpen, setIsPlanListOpen] = useState<boolean>(false);
  const { t } = useTranslation(['common', 'property']);

  const wrapperRef = React.useRef(null);

  useClickOutside(
    wrapperRef,
    React.useCallback(() => setIsPlanListOpen(false), [])
  );

  const handleOpenList = React.useCallback(() => {
    setIsPlanListOpen((previousState) => !previousState);
  }, []);

  return (
    <StyledButtonDiv {...props}>
      <StyledDivMenuDropdown ref={wrapperRef}>
        <StyledPlanButton onClick={handleOpenList}>
          {t('plans')}
        </StyledPlanButton>
        {isPlanListOpen && (
          <StyledList>
            <Link
              href={`${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/planes_corredoras`}
            >
              <StyledListItem>{t('property:brokerPlans')}</StyledListItem>
            </Link>
            <Link
              href={`${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/planes`}
            >
              <StyledListItem>{t('property:realEstatePlans')}</StyledListItem>
            </Link>
          </StyledList>
        )}
      </StyledDivMenuDropdown>
      <Link
        href={`${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/pb`}
      >
        <StyledDiv>
          <StyledOutlineButton>{t('publish')}</StyledOutlineButton>
        </StyledDiv>
      </Link>
    </StyledButtonDiv>
  );
};

export default memo(MenuDesktop);
